import React from "react";
import { Search, X } from "lucide-react";

function MenuSearch({ searchQuery, setSearchQuery, menuType }) {
  const placeholderText =
    menuType === "food"
      ? "Search dishes, kebabs, curries..."
      : "Search cocktails, single malts, wines, beers...";

  return (
    <div className="menu-search-wrapper">
      <Search className="search-icon" size={16} aria-hidden="true" />
      <input
        type="text"
        placeholder={placeholderText}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        aria-label={`Search ${menuType === "food" ? "Food" : "Drinks"} menu items`}
      />
      {searchQuery && (
        <button
          className="search-clear-btn"
          onClick={() => setSearchQuery("")}
          aria-label="Clear search input"
        >
          <X size={15} />
        </button>
      )}
    </div>
  );
}

export default React.memo(MenuSearch);
